import { Routes } from 'react-router-dom';
import ProtectedRouter from 'infrastructure/routing/ProtectedRouter';
import { Route } from 'framework/routing';
import { SALARY_FORKS_PATH, useSalaryForksPath } from './routing';
import { SALARY_FORKS_VIEW_READ, SALARY_FORKS_READ_HISTORY } from './useSalaryForkService';
import SalaryForkListPage from './List';
import SalaryForkHistoryPage from './History';
import { GlobalProtectedRoute } from 'framework/authorization';

const SalaryForksRouter = () => {
  const { listRoute, historyRoute } = useSalaryForksPath();

  return (
    <ProtectedRouter basePath={SALARY_FORKS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={SALARY_FORKS_VIEW_READ}>
              <SalaryForkListPage />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={historyRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={SALARY_FORKS_READ_HISTORY}>
              <SalaryForkHistoryPage />
            </GlobalProtectedRoute>
          }
        />
      </Routes>
    </ProtectedRouter>
  );
};

SalaryForksRouter.getRouterPath = () => `${SALARY_FORKS_PATH}/*`;

export default SalaryForksRouter;
